import { Component, HostListener, AfterViewInit, OnDestroy, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { OidcAuthService } from './auth/oidc-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';

  // CAP-40007 TCL-2727 - Inject the PingFederate OIDC service to bootstrap authentication
  constructor(private translate: TranslateService, public oidc: OidcAuthService) {
    translate.setDefaultLang('fr');
  }

  // CAP-40007 TCL-2727 - Phase 2: load discovery document, process the callback, navigate on success.
  // configure() already ran in APP_INITIALIZER; only init() (discovery + login) happens here.
  ngOnInit(): void {
   
    this.oidc.init().catch(err => console.error('[CAP-40007 TCL-2727] AppComponent.ngOnInit() - OIDC init failed:', err));
  }

  // @HostListener('window:unload', [ '$event' ])
  // unloadHandler(event) {
  //   localStorage.clear();
  // }

  // @HostListener('window:beforeunload', [ '$event' ])
  // beforeUnloadHander(event) {
  //   localStorage.clear();
  // }

}
